import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import classes from "./LoadingV3.scss";

const MINI_LOADER_SIZE = 28;
const DEFAULT_LOADER_SIZE = 40;

// Pure-CSS equivalent of LoadingV2's SMIL spinner. Same SVG shapes; the SMIL
// <animate>/<animateTransform> tags become CSS @keyframes:
//   - discrete 90° rotation → steps(4) on the <svg> host element itself
//     (a clean HTML-level transform — avoids nested SVG transforms, which is
//      why the earlier nested version's flip didn't take)
//   - bottom-half coin flip → scaleY keyframe pivoting on the diameter
//   - two-tone colour cycling → step-end fill keyframes
// transform/opacity are compositor-accelerated, so this keeps animating while
// the main thread is blocked (e.g. parsing the app bundle at boot) — which the
// SMIL version can't.
const SpinnerCss = ({
  width = DEFAULT_LOADER_SIZE,
  height = DEFAULT_LOADER_SIZE,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    className={classes.spinner}
  >
    <path className={classes.topHalf} d="M2 50 A48 48 0 1 0 98 50" />
    <path className={classes.bottomHalf} d="M2 50 A48 48 0 0 1 98 50" />
    <path className={classes.diameter} d="M3 50 L97 50" />
    <path className={classes.flipHalf} d="M2 50 A48 48 0 0 1 98 50 Z" />
  </svg>
);

const LoadingV3 = props => {
  const {
    position,
    loadingStyle,
    containerStyle,
    isMiniLoader,
    isFullScreen,
  } = props;
  const { width: loadingWidth, height: loadingHeight } = loadingStyle || {};

  const defaultSize = isMiniLoader ? MINI_LOADER_SIZE : DEFAULT_LOADER_SIZE;
  const width = loadingWidth ?? defaultSize;
  const height = loadingHeight ?? defaultSize;

  const containerClass = classNames(
    position === "center-bottom" ? classes.containerBottomCenter : null,
    position === "center" ? classes.containerCenter : null,
    isFullScreen ? classes.fullViewport : null
  );

  return (
    <div className={containerClass} style={containerStyle}>
      <SpinnerCss width={width} height={height} />
    </div>
  );
};

LoadingV3.propTypes = {
  containerStyle: PropTypes.object,
  loadingStyle: PropTypes.object,
  position: PropTypes.string,
  isMiniLoader: PropTypes.bool,
  isFullScreen: PropTypes.bool,
};

LoadingV3.defaultProps = {
  position: "center",
  loadingStyle: {},
  containerStyle: {},
  isMiniLoader: false,
  isFullScreen: false,
};

export default LoadingV3;
